import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as d3 from 'd3';
import * as d3Chromatic from 'd3-scale-chromatic';
let data = [];
@Component({
    selector: 'app-d3-heatmap',
    templateUrl: './d3-heatmap.component.html',
    styleUrls: ['./d3-heatmap.component.scss'],
    standalone: false
})
export class D3HeatmapComponent implements OnChanges {
    @Input() data: any = [];
    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        this.drawHeatmap();
    }

    drawHeatmap() {
        data = this.data;
        // data = [
        //     { y: 'A', x: 'v1', correlationCoefficient: -1 },
        //     { y: 'B', x: 'v2', correlationCoefficient: 0 },
        //     { y: 'C', x: 'v3', correlationCoefficient: 0.5 },
        //     { y: 'D', x: 'v4', correlationCoefficient: -0.5 },
        //     { y: 'E', x: 'v5', correlationCoefficient: 0.6 },
        //     { y: 'F', x: 'v6', correlationCoefficient: 0.7 },
        //     { y: 'G', x: 'v7', correlationCoefficient: -0.1 },
        //     { y: 'Z', x: 'v8', correlationCoefficient: 1 }
        // ];

        const margin = { top: 30, right: 0, bottom: 170, left: 180 };
        const width = 1000 - margin.left - margin.right;
        const height = 550 - margin.top - margin.bottom;
        const boxWidth = (width / data.length);
        const boxHeight = (height / data.length);
        const buckets = 9;
        const colors = ['blue', 'green', '#668cff', '#3366ff', '#0040ff', '#0033cc', '#002699', '#002080', '#00134d'];
        const noData = 'NoData';
        const format = d3.format(".3f");
        d3.selectAll('svg').remove();
        // append the svg object to the body of the page
        const svg = d3.select('#my_dataviz')
            .append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform',
                'translate(' + margin.left + ',' + margin.top + ')');

        // Labels of row and columns
        const myGroups = [...new Set([...data.map(elem => elem.y).reverse()])];
        const myVars = [...new Set([...data.map(elem => elem.x)])];

        // Build X scales and axis:
        const x = d3.scaleBand()
            .range([0, width])
            .domain(myGroups)
            .padding(0.01);
        svg.append('g')
            .style('font', '13px times')
            .attr('transform', 'translate(0,' + height + ')')
            .style('text-anchor', 'middle')
            .text('Keyword')
            .call(d3.axisBottom(x))
            .selectAll('text')
            .style('text-anchor', 'end')
            .attr('dx', '-.8em')
            .attr('dy', '.15em')
            .attr('transform', 'rotate(-40)');



        // Build y scales and axis:
        const y = d3.scaleBand()
            .range([height, 0])
            .domain(myVars)
            .padding(0.01);
        svg.append('g')
            .style('font', '13px times')
            .call(d3.axisLeft(y))
            .selectAll('text')
            .style('text-anchor', 'end')
            .attr('dx', '-.8em')
            .attr('dy', '.15em')
            .attr('transform', 'rotate(-40)');

        // Build color scale
        // const myColor = d3.scaleLinear<string>()
        //   .range(colors)
        //   .domain([-0.1, 1]);
        // var colorScale = d3.scaleLinear.quantile()
        // .domain([0, buckets - 1])
        // .range(colors);
        const extent = d3.extent(data, d => d.correlationCoefficient !== noData ? d.correlationCoefficient : 0);
        const myColor = d3.scaleSequential(d3Chromatic.interpolateRdYlGn)
            .interpolator(d3.interpolateRdYlGn)
            .domain([-1, 1]);
        //     d3.scaleDiverging()
        // .domain([extent[0], 0, extent[1]])
        // .interpolator(d3.interpolatePuOr)
        // create a tooltip
        const tooltip = d3.select('#my_dataviz')
            .append('div')
            .style('opacity', 0)
            .attr('class', 'tooltip')
            .style('background-color', 'white')
            .style('border', 'solid')
            .style('border-width', '2px')
            .style('border-radius', '5px')
            .style('padding', '5px');

        // Three function that change the tooltip when user hover / move / leave a cell
        const mouseover = ((d) => {
            tooltip.style('opacity', 1);
        });
        const mousemove = function (d) {
            tooltip
                .html(d.correlationCoefficient !== noData ? d.correlationCoefficient : 'No Data')
                .style('left', (d3.mouse(this)[0] + 220) + 'px')
                .style('top', (d3.mouse(this)[1]) + 'px');
        };
        const mouseleave = ((d) => {
            tooltip.style('opacity', 0);
        });

        // add the squares
        svg.selectAll()
            .data(data, ((d) => d.y + ':' + d.x))
            .enter()
            .append('g')
            .append('rect')
            .attr('x', ((d) => x(d.y)))
            .attr('y', ((d) => y(d.x)))
            .attr('width', x.bandwidth())
            .attr('height', y.bandwidth())
            .style('fill', ((d) => d.correlationCoefficient !== noData ? myColor(d.correlationCoefficient) : '#F5F7F2'))
            .on('mouseover', mouseover)
            .on('mousemove', mousemove)
            .on('mouseleave', mouseleave);

        const valuesText = svg.selectAll()
            .data(data, ((d) => d.y + ':' + d.x))
            .enter()
            .append('text');

        valuesText.attr('text-anchor', 'middle')
            .attr('dominant-baseline', 'central')
            .style('fill', 'black')
            .attr('x', ((d) => x(d.y) + 35))
            .attr('y', ((d) => y(d.x) + 25))
            .text((d) => d.correlationCoefficient !== noData ? d.correlationCoefficient === "1" ? d.correlationCoefficient : format(d.correlationCoefficient) : '')
            .attr('class', 'parentText');

    }


}
